import A11yReport from 'umg-ember-backend/components/record-detail/for/a11y-report';

<template><A11yReport @model={{@model}} /></template>
